import type { Tile } from '../types/homepageFeatureTileRow'

const PRODUCT_TILE_TYPE = 'product'

/**
 * Determines whether price should be rendered for a feature tile row.
 *
 * Price is only shown when the `enablePrice` toggle on the `pageHomePageV2` CMS entry is on AND
 * every tile in the row is a product tile. Mixed rows (product + category/custom/discovery) are
 * excluded because non-product tiles cannot resolve an mpvId, which would leave visual gaps in the
 * row where some tiles show a price and others do not.
 */
export const shouldShowPrice = (enablePrice: boolean | undefined, tiles: Array<Tile> | null | undefined): boolean => {
  if (!enablePrice) {
    return false
  }

  if (!tiles?.length) {
    return false
  }

  return tiles.every((tile) => tile?.template?.type === PRODUCT_TILE_TYPE)
}
